import styled, { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';

type DependencyMapHeaderLabelContainerProperties = {
  $hasOnReferenceClick?: boolean;
  $isWidthSmallerThanVisible?: boolean;
  $textColor?: string;
};
const DependencyMapHeaderLabel = styled.label<DependencyMapHeaderLabelContainerProperties>`
  ${({ $hasOnReferenceClick, $isWidthSmallerThanVisible }) =>
    !$hasOnReferenceClick &&
    !$isWidthSmallerThanVisible &&
    css`
      pointer-events: none;
    `}
  color: ${({ $textColor }) => $textColor ?? colors.textModerate};
  opacity: 0.8;
  font-weight: 400;
  display: block;
`;

export { DependencyMapHeaderLabel };
